export default __webpack_public_path__ + "static/media/site-ecommerce.ff0eb825.svg";